export class BatteryConfig {
  bufferTime: number;
  maxDuration: number;

  constructor(bufferTime: number, maxDuration: number) {
    this.bufferTime = bufferTime;
    this.maxDuration = maxDuration;
  }
}